import qs from "qs";
import { isNil } from "ramda";

export class ContactClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/contacts`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = (!isNil(params.start_at) && !isNil(params.end_at)) ? `${this.baseURL}/stat${queryString}` : `${this.baseURL}/stat`

    const response = await this.httpClient.request("get", url);

    return response;
  }
}
